@use '@design/design-tokens/typography/typography' as *;

.sectionLabel {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 16px;
  margin-bottom: 0;
  @include typography-v2-body-xs;
  color: var(--text-soft);
}

.emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 80px 8px;
  text-align: center;
}

.emptyIllustration {
  flex-shrink: 0;
}

.emptyText {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.emptyTitle {
  @include typography-v2-title-base;
  color: var(--text-default);
  margin: 0;
}

.emptyDescription {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  margin: 0;
  line-height: 1.43;
}

.deletedSection {
  margin-top: 8px;
}

.skeleton {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 4px;
}
